import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { DatePicker, Icon, Table, Tooltip, Tag, Divider, message, Popconfirm, Modal } from 'antd';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import './MyObservation.scss'
import moment from 'moment';
import { Odata_Url, Constants } from '../../../Constants/Constants'
import { toUpperKey } from '../../../util/helpper'
import IntlMessages from '../../../util/IntlMessages';

const { confirm } = Modal
const { MonthPicker } = DatePicker;
const { Column } = Table
const axios = require('axios');

const Status = {
    Open: 1,
    "Waiting for approval": 2,
    Approved: 3,
    Rejected: 4,
    Cancelled: 5,
    Completed: 6,
    "Revised due date": 7
}

const GetStatusColor = (status) => {
    return status === Status.Approved ? 'green' :
        [Status.Rejected, Status.Cancelled].indexOf(status) > -1 ? 'red' :
            [Status.Returned].indexOf(status) > -1 || status === 'Revised due date' ? 'yellow' :
                [Status.Completed].indexOf(status) > -1 ? 'blue' :
                    'volcano'
}


class MyOb1 extends Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            num: 0,
            UserID: 1,
            dataObservation: [],
            tableLoading: false,
            dataArea: [],
            Monthpic: null,
            dateString: '',
            dataBag: {},
            DueDate: '',
            confirmLoading: false
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng)
            this.setState({ isEng: isEng })
    }

    componentDidMount() {
        this.onChangeMonth(moment(), moment().format('YYYY-MM'))
    }

    componentWillMount() {
        let state = JSON.parse(window.localStorage.getItem('state'))
        let isEng = state.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        var date = moment()
        var this_month = date._d.getMonth() + 1
        var this_year = date._d.getFullYear()
        var Day = (this_year + "-" + this_month)
        this.getObservationData(Day);
    }

    getObservationData(Day) {
        this.setState({ tableLoading: true });
        const state = JSON.parse(window.localStorage.getItem('state'))
        const userid = state.authen.UserID

        this.setState({ dateString: Day })

        let month = Day.split('-')[1]
        let year = Day.split('-')[0]

        let url = 'api/ObservationTransaction/SearchObservation'
        let criteria = {
            Month: month,
            Year: year,
            UserId: userid
        }

        url += '?'
        for (let key in criteria) {
            url += `${encodeURIComponent(key)}=${encodeURIComponent((criteria[key] === undefined || criteria[key] === null ? '' : criteria[key]))}`
            url += '&'
        }
        url = url.slice(0, url.length - 1)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.get(Constants.BASE_URL + url, tokenHeader).then((response) => {
                const data = [];
                var state = JSON.parse(window.localStorage.getItem('state'))
                var count = 0;
                response.data.forEach(function (element) {
                    data.push(toUpperKey(element));
                    count++
                });
                this.setState({
                    dataObservation: data,
                    num: count,
                })
                this.setState({ tableLoading: false });
            }, (error) => {
                console.log(error)
                this.setState({ tableLoading: false });
            });
        });

        

        var area = JSON.parse(window.localStorage.getItem('Area'))
        this.setState({ dataarea: area })
    }

    showdetail = (obtran) => {
        //console.log(obtran)
        this.props.history.push({
            pathname: "/observation/request/" + obtran.PkObTranID+"/view"
        })
        //this.props.history.push({
        //    pathname: "/newobservation_basic_info",
        //    state: { Obtran: obtran, mode: 'view' }
        //});
    }

    handleClickEdit = (obtran) => {

        this.props.history.push({
            pathname: "/observation/request/" + obtran.PkObTranID+"/edit"
        })
        //console.debug("MyOb1(MyObservation.jsx) > handleClickEdit() > obtran", obtran);
        //this.props.history.push({
        //    pathname: "/newobservation_basic_info",
        //    state: { Obtran: obtran, mode: 'edit' }
        //});
    }

    handleClickDelete = (obtran) => {

        confirm({
            title: 'Confirmation',
            content: 'Are you sure to delete this transaction?',
            okText: 'Delete',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => {
                this.setState({ tableLoading: true });

                this.getToken().then(token => {

                    let tokenHeader = {
                        headers: {
                            "Authorization": "Bearer " + token,
                        }
                    };

                    axios.get(Constants.BASE_URL + "api/ObservationTransactionV2/Delete?id=" + obtran.PkObTranID, tokenHeader).then((response) => {
                        message.success("Your transaction has been successfully.")
                        this.getObservationData(this.state.dateString);
                        this.setState({ tableLoading: false });
                        return
                    }, (error) => {
                        console.log(error);
                        message.error("Something went wrong please try again.")
                        this.setState({ tableLoading: false });
                        return
                    })
                });
            }
        })
        
        return
    }

    onChangeMonth = (date, dateString) => {
        this.getObservationData(dateString);
    }

    disabledDate(current) {
        return current && current > moment().endOf('day');
    }

    handleClickEdit(row) {
        var due_date = row.DueDate
        var initialValueDate
        if (due_date !== null && due_date !== undefined) {
            var date = due_date.slice(8, 10)
            var month = due_date.slice(5, 7)
            var year = due_date.slice(0, 4)
            var date_time = (date + "-" + month + "-" + year)
            initialValueDate = date_time
        } else {
            initialValueDate = moment()
        }

        if (due_date === null)
            row.DueDate = moment()

        this.setState({
            DueDate: initialValueDate,
            dataBag: row,
            visible: true
        })
    }

    onChangeDueDate = (date, dateSreing) => {
        this.setState({ DueDate: dateSreing })
    }

    handleChangeDueDate() {
        this.setState({ confirmLoading: true })
        let data = this.state.dataBag;
        let due_date = this.state.DueDate
        let DueDate = moment(due_date, 'DD-MM-YYYY');
        DueDate.toJSON = function () { return moment(this).format(); }
        data.DueDate = DueDate.toJSON();
        this.handleAction(data, 0);
    }

    handleCancel() {
        this.setState({
            DueDate: '',
            dataBag: [],
            visible: false
        })
    }

    handleAction(dataAction, action) {

        let data = dataAction;
        data.Status = action
        var ObtranEn = JSON.stringify(data)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.post(Constants.BASE_URL + "api/ObservationTransaction/UpdateStatus", { Obtran: ObtranEn }, tokenHeader)
                .then((response) => {
                    message.success("Your transaction has been successfully.")
                    this.getObservationData(this.state.dateString);
                    this.setState({ visible: false, confirmLoading: false })
                    return
                },
                    (error) => {
                        console.log(error);
                        message.error("Something went wrong please try again.")
                        this.setState({ visible: false, confirmLoading: false })
                        return
                    })
        });

        
        return
    };

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const { dataObservation } = this.state

        return (
            <div className='MyOb1'>
                <ScrollToTop />
                <MenuSider title="My Observation Checklist">
                    <div style={{ padding: "12px" }}>
                        <div style={{ width: "100%", textAlign: "right" }}>
                            <MonthPicker style={{ width: "35%" }} defaultValue={moment()} onChange={this.onChangeMonth} disabledDate={this.disabledDate} />
                        </div>
                        <div style={{ fontSize: "18px", marginTop: "18px", textAlign: "center", borderRadius: "2px", color: "black", lineHeight: "25px" }}>
                            <IntlMessages id="myobserv.youcompleted" /> <b>{dataObservation.length}</b> <IntlMessages id="myobserv.observation" />
                        </div>

                        <Table
                            dataSource={dataObservation}
                            rowKey={row => row.PkObTranID}
                            loading={this.state.tableLoading}
                            scroll={{ x: 415 }}
                            // style={{ width: '95%', marginLeft: '2.5%' }}
                            rowClassName={(data) => {
                                if (data.PkObTranID == this.state.ObtranID)
                                    return 'row-selection'
                                else
                                    return ''
                            }}
                        >
                            <Column
                                title={<IntlMessages id='Capa.ObservationDate' />}
                                key='Observation_Date'
                                render={(data, row) => {
                                    return data.Observation_Date.slice(8, 10) + '-' + data.Observation_Date.slice(5, 7) + '-' + data.Observation_Date.slice(0, 4) + ' ' + data.Observation_Time
                                }}
                            />
                            <Column
                                title={<IntlMessages id='CreatedBy' />}
                                key='CreatedBy'
                                dataIndex={this.state.isEng ? 'CreatedByEN' : 'CreatedByTH'}
                                align='center'
                            />
                            <Column
                                title={<IntlMessages id='Status' />}
                                dataIndex='status'
                                align='center'
                                render={(data, row) => {
                                    let status = !isNaN(row.CurrentStatus) ? row.CurrentStatus : 0
                                    return (
                                        <span>
                                            <Tag color={GetStatusColor(status)} key={status}>
                                                {Object.keys(Status).find(key => Status[key] === status)}
                                            </Tag>
                                        </span>
                                    )
                                }}
                            />
                            <Column
                                title={<IntlMessages id='Action' />}
                                key=''
                                width={120}
                                align='center'
                                fixed='right'
                                render={(data, row) => {
                                    let isShowEdit = true;//= new Date(row.CreateDate).getMonth() === new Date().getMonth()
                                    return (
                                        <div>
                                            <Tooltip title="View">
                                                <a href="javascript:;" onClick={() => this.showdetail(row)}>
                                                    <Icon type={"search"} style={{ fontSize: "17px", color: '#52c41a' }} />
                                                </a>
                                            </Tooltip>
                                            {
                                                isShowEdit && (
                                                    <>
                                                        <Divider type="vertical" />
                                                        <Tooltip title="Edit">
                                                            <a href="javascript:;" onClick={() => this.handleClickEdit(row)}>
                                                                <Icon type={"edit"} style={{ fontSize: "17px" }} />
                                                            </a>
                                                        </Tooltip>
                                                        <Divider type="vertical" />
                                                        <Tooltip title="Delete">
                                                            <a href="javascript:;" onClick={() => this.handleClickDelete(row)}>
                                                                <Icon type={"delete"} theme='twoTone' twoToneColor='#eb2f96' style={{ fontSize: "17px" }} />
                                                            </a>
                                                        </Tooltip>
                                                    </>
                                                )
                                            }
                                        </div>
                                    )
                                }}
                            />
                        </Table>
                    </div>
                    <div style={{ width: "70px", height: "70px", position: "fixed", right: "25px", bottom: "40px", border: "1px solid rgb(1 135 124)", backgroundColor: "rgb(0,152,139)", borderRadius: "50%" }}>
                        <Link to="/observation/request">
                            <Icon type="plus" style={{ left: "25%", top: "25%", position: "relative", color: "white", fontSize: "35px" }} />
                        </Link>
                    </div>

                    <Modal
                        visible={this.state.visible}
                        title="Change Due Date for"
                        onOk={() => this.handleChangeDueDate()}
                        onCancel={() => this.handleCancel()}
                        okText="Save"
                        confirmLoading={this.state.confirmLoading}
                        destroyOnClose={true}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            onChange={this.onChangeDueDate}
                            defaultValue={this.state.dataBag.DueDate ? moment(this.state.dataBag.DueDate) : ''}
                            format="DD-MM-YYYY"
                        />
                    </Modal>
                </MenuSider>
            </div>
        );
    }
}

const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}

export default connect(mapStatetoProps)(MyOb1)